<template>
  <div class="talent">
    <div class="container">
      <div class="talent-top">
        <div class="talent-top-search">
          <el-input
            placeholder="请输入内容"
            v-model="searchForm.search"
            class="input-with-select"
            prefix-icon="el-icon-search"
          >
            <el-select
              v-model="searchForm.deptId"
              slot="prepend"
              filterable
              placeholder="请选择"
              @change="searchData(active)"
            >
              <el-option
                v-for="item in departmentList"
                :key="item.deptId"
                :label="item.deptName"
                :value="item.deptId"
              >
              </el-option>
            </el-select>
          </el-input>
        </div>
        <el-button
          type="danger"
          class="talent-top-btn"
          plain
          @click="searchData(active)"
          >检索</el-button
        >
      </div>
      <ul class="talent-content">
        <router-link
          tag="li"
          v-for="(item, index) in dataList"
          :key="index"
          :to="{ path: 'personal', query: { id: item.userId } }"
        >
          <div class="li-top">
            <div class="li-top-pic">
              <img :src="item.photo" alt="" />
            </div>
          </div>
          <p class="li-name">{{ item.author }}</p>
          <p class="li-place">{{ item.deptName }}</p>
          <p class="li-line"></p>
          <p class="li-bottom">
            <span
              >成果量： <i>{{ item.dissNum }}</i></span
            >
            <span
              >全文量： <i>{{ item.fullNum }}</i></span
            >
          </p>
        </router-link>
      </ul>
      <div style="text-align: center">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="pageSizes"
          @current-change="currentChange"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Operation from "../components/operation";
import Pages from "../components/pages.vue";
export default {
  name: "talent",
  components: {
    Operation,
    Pages,
  },
  data() {
    return {
      activeName: "second",
      total: 0,
      currentPage: 1,
      pageSizes: 10,
      searchForm: {
        deptId: "",
        search: "",
        sort: "CGL",
        pageNo: "1",
      },
      checked: false,
      options: [],
      value: "",
      dataList: [],
      departmentList: [],
      active: 0,
    };
  },
  methods: {
    currentChange(val) {
      this.searchForm.pageNo = val;
      this.searchData(this.active);
    },
    changeSort(val) {
      this.searchForm.sort = val;
      this.searchData(this.active);
    },
    // 获取部门
    getAllDep() {
      let currThis = this;
      axios({
        method: "get",
        url: "/api/SelectdeptNameList",
      })
        .then(function (response) {
          currThis.departmentList = response.data;
        })
        .catch(function (thrown) {});
    },
    searchData(id) {
      let str = "";
      if (this.searchForm.search) {
        str = `&search=${this.searchForm.search}`;
      }
      this.active = id;
      let currThis = this;
      axios({
        method: "get",
        url:
          "/api/index/queryScholarData?pageNo=" +
          this.searchForm.pageNo +
          str +
          "&deptId=" +
          this.searchForm.deptId +
          "&sort=" +
          this.searchForm.sort,
      })
        .then(function (response) {
          currThis.total = response.data.pageTotal;
          currThis.dataList = response.data.list;
          for (var i in currThis.dataList) {
            try {
              currThis.dataList[i].photo = require("../assets/images/tou.png");
            } catch (e) {}
          }
        })
        .catch(function (thrown) {});
    },
  },
  mounted() {
    this.searchData();
    this.getAllDep();
  },
};
</script>

<style lang="less">
.talent {
  background-color: #fff;
  padding: 24px 0 56px;
  .talent-top {
    width: 1172px;
    margin: 0 auto;
    height: 80px;
    background: #ffffff;
    box-shadow: 0px 3px 8px rgba(110, 110, 110, 0.12);
    opacity: 1;
    border-radius: 4px;
    display: flex;
    padding: 16px 20px;
    box-sizing: border-box;
    .talent-top-search {
      width: 689px;
      margin-right: 23px;
      .el-input__inner {
        height: 48px;
      }
    }
    .talent-top-btn {
      width: 100px;
      height: 48px;
      color: #fff;
      background-color: #bf232c;
    }
  }
  .talent-content {
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
    li {
      width: 220px;
      height: 280px;
      border-radius: 4px;
      margin: 0 25px 25px 0;
      text-align: center;
      border: 1px solid #eeeeee;
      box-sizing: border-box;
      cursor: pointer;
      .li-top {
        position: relative;
        height: 86px;
        background: rgba(16, 48, 93, 0.03);
        margin-bottom: 77px;
        .li-top-pic {
          position: absolute;
          bottom: -54px;
          left: 50%;
          transform: translateX(-50%);
          width: 108px;
          height: 108px;
          box-sizing: border-box;
          border-radius: 50%;
          border: 2px solid #fff;
          // background-color: orange;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
          }
        }
      }

      .li-name {
        color: #333333;
        margin-bottom: 5px;
      }
      .li-place {
        color: #707070;
        font-size: 12px;
      }
      .li-line {
        width: 80px;
        height: 1px;
        background-color: #eeeeee;
        margin: 14px auto 17px;
      }
      .li-bottom {
        font-size: 12px;
        color: #707070;
        width: 146px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        i {
          font-style: normal;
          color: #6bc600;
        }
      }
    }
    li:hover {
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    }
  }
  .talent-content li:nth-of-type(5n) {
    margin-right: 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #bf232c;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #fff;
    background: #bf232c;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/talent.vue